import React from 'react';
import TopNavBar from './components/TopNavBar';
import LandingContainer from './components/LandingContainer';
import LandingFooter from './components/LandingFooter';
import {NavLink, Outlet, Route, Routes} from 'react-router-dom';
import ProgramDetailsReports from './ProgramDetailsReports';
import ProgramDetailsCommissions from './ProgramDetailsCommissions';
import ProgramDetailsTools from './ProgramDetailsTools';
import {FormattedMessage} from 'react-intl';
import {connect} from 'react-redux';
import HeroComponent from './components/HeroComponent';
import BackButton from '../../cmp/BackButton';

export default function LandingSectionsIndex(){
    return <Routes>
          <Route element={<LandingSectionsContainer />}>
                <Route path={'reports'} element={<ProgramDetailsReports/>}/>
                <Route path={'commissions'} element={<ProgramDetailsCommissions/>}/>
                <Route path={'tools'} element={<ProgramDetailsTools/>}/>
          </Route>
    </Routes>
}

const LandingSectionsContainer = connect(mapStateToProps)(function (props) {
        const {hasReports, hasTools, hasCommissions, defaultBannerVisible} = props
        return (
            <LandingContainer>
                <TopNavBar/>
                {
                    defaultBannerVisible ?
                    <div className={'bg-dark'}>
                        <HeroComponent/>
                    </div> : <div className="container pt-4">
                            <BackButton/>
                    </div>
                }
                <div className={'bg-white'}>
                    <div className={'container mx-auto py-2'}>
                        <ul className="nav nav-tabs mt-2">
                            {
                                hasReports &&
                                <li className="nav-item">
                                    <NavLink activeClassName={'active'} to="/program-details/reports"
                                             className="nav-link">
                                        <FormattedMessage id={"Reports"}/>
                                    </NavLink>
                                </li>
                            }
                            {
                                hasTools &&
                                <li className="nav-item">
                                    <NavLink activeClassName={'active'} to="/program-details/tools"
                                             className="nav-link">
                                        <FormattedMessage id={"Tools"}/>
                                    </NavLink>
                                </li>
                            }
                            {
                                hasCommissions &&
                                <li className="nav-item">
                                    <NavLink activeClassName={'active'} to="/program-details/commissions"
                                             className="nav-link">
                                        <FormattedMessage id={"Commission Details"}/>
                                    </NavLink>
                                </li>
                            }
                        </ul>
                        <div className={'my-4'}>
                            <Outlet />
                        </div>
                    </div>
                </div>
                <LandingFooter/>
            </LandingContainer>
        );
})

function mapStateToProps(state) {
    const {page_sections} = state.settings;
    const landing_footer = (page_sections.default_footer && page_sections.default_footer.props) || {}
    const default_banner = (page_sections.default_banner &&  page_sections.default_banner.props) || {}
    //has reports
    const isVisible = default_banner.visible;
    const hasReports = landing_footer.blocks && landing_footer.blocks.find(({description}) => description.match('{link_reporting}'))
    const hasCommissions = landing_footer.blocks && landing_footer.blocks.find(({description}) => description.match('{link_commissions}'))
    const hasTools = landing_footer.blocks && landing_footer.blocks.find(({description}) => description.match('{link_tools}'))
    return {
        website: state.settings.website,
        hasTools,
        hasReports, hasCommissions,
        defaultBannerVisible: isVisible
    }
}
